export const rebookAppointmentData = {
  buttons: [],
  title: 'Rebook your appointment',
  imgObj: {
    alt: 'Appointment booking',
    src: 'https://media.product.which.co.uk/prod/images/original/ccee6d01d803-carproblemstep1.jpg',
  },
  standFirst: '',
} as const
